import React, {useEffect, useState} from 'react';
import API from '../../api';
import LivezoneLogo from './LivezoneLogo';
import {useOutletContext, useParams} from 'react-router-dom';
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography} from '@mui/material';

const STATUSES: {[key: number]: string} = {
  1: 'DNS',
  2: 'DNF',
  3: 'MP',
  4: 'DSQ',
  5: 'OT'
};

const INTERVAL = 30000;

const nameFormatter = (name: string, club: string) => {
  return (
    <span>
      <Typography sx={{fontWeight: 'bold'}}>{name}</Typography>
      {club && <Typography>{club}</Typography>}
    </span>
  );
};

const convertTime = (time: number) => {
  const seconds = time / 100;

  const s = seconds % 60;
  const m = ((seconds - s) / 60) % 60;
  const h = (seconds - (s + m * 60)) / 3600;
  return `${h > 0 ? h + ':' : ''}${m < 10 ? '0' : ''}${m}:${s < 10 ? '0' : ''}${s}`;
};

const timeFormatter = (cell: string, status: number) => {
  const time = parseInt(cell);
  if (status === 0) {
    return convertTime(time);
  } else if (status < 9) {
    return STATUSES[status];
  } else {
    return '-';
  }
};

const gapFormatter = (cell: string) => {
  const time = parseInt(cell);
  if (time > 0) {
    return '+' + convertTime(time);
  } else {
    return '-';
  }
};

const startFormatter = (cell: string) => {
  const time = parseInt(cell);
  if (time > 0) {
    return convertTime(time);
  } else {
    return '-';
  }
};

// const rowStyle = (row) => {
//   if (row.DT_RowClass === 'new_result') {
//     return {
//       backgroundColor: `rgba(256, 0, 128, 0.3)`
//     };
//   }
// };

type Result = {
  name: string;
  club: string;
  place: string;
  status: number;
  result: string;
  timeplus: string;
  start: string;
  DT_RowClass: string;
};

const sortResults = (data: Result[]) => {
  data.sort((first, second) => {
    const status = first.status - second.status;
    if (status !== 0) return status;

    if (first.status === 0) {
      return parseInt(first.result) - parseInt(second.result);
    }

    return parseInt(first.start) - parseInt(second.start);
  });
  return data;
};

const ResultsCategory = ({category, competitionId}: {category: string; competitionId: number}) => {
  const [results, setResults] = useState<Result[]>([]);
  const [time, setTime] = useState<Date>();
  const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);
  const [hash, setHash] = useState();

  useEffect(() => {
    if (timer) {
      clearInterval(timer);
    }
    API.fetchCategory(competitionId, category, hash).then(({data}) => {
      if (data.status === 'OK') {
        setHash(data.hash);
        setResults(sortResults(data.results).map((competitor, id) => ({...competitor, id})));
      }
      setTimer(setInterval(() => setTime(new Date()), INTERVAL));
    });
  }, [category, time]);

  return (
    <React.Fragment>
      <Typography variant="h4" component="h2" align="center">
        {category}
      </Typography>
      <TableContainer component={Paper} sx={{marginBottom: '50px'}}>
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell width="5%">#</TableCell>
              <TableCell width="40%">Name</TableCell>
              <TableCell width="15%" align="right">
                Start
              </TableCell>
              <TableCell width="15%" align="right">
                Times
              </TableCell>
              <TableCell width="15%" align="right"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {results.map((row, key) => (
              <TableRow
                key={key}
                sx={{
                  '&:last-child td, &:last-child th': {border: 0},
                  backgroundColor: row.DT_RowClass == 'new_result' ? 'rgba(256, 0, 128, 0.3)' : ''
                }}
              >
                <TableCell width="5%">{row.place}</TableCell>
                <TableCell width="40%">{nameFormatter(row.name, row.club)}</TableCell>
                <TableCell width="15%" align="right">
                  {startFormatter(row.start)}
                </TableCell>
                <TableCell width="15%" align="right" sx={{fontWeight: 'bold'}}>
                  {timeFormatter(row.result, row.status)}
                </TableCell>
                <TableCell width="15%" align="right">
                  {gapFormatter(row.timeplus)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </React.Fragment>
  );
};

export default ResultsCategory;
